module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "advance-auto-parts.7208fc95.png";